"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETagFilterType = void 0;
var ETagFilterType;
(function (ETagFilterType) {
    ETagFilterType["Text"] = "text";
    ETagFilterType["InputPrice"] = "price";
    ETagFilterType["Input"] = "input";
    ETagFilterType["InputNumber"] = "number";
    ETagFilterType["Select"] = "select";
    ETagFilterType["Location"] = "location";
    ETagFilterType["CheckBox"] = "checkbox";
    ETagFilterType["Date"] = "date";
})(ETagFilterType = exports.ETagFilterType || (exports.ETagFilterType = {}));
//# sourceMappingURL=TagsFilters.interface.js.map